module.exports = __webpack_public_path__ + "img/thumbfurniture2.45ceec42.png";